import { ControlValueAccessor } from '@angular/forms';
import { AfterViewInit, Directive, QueryList, ViewChildren } from '@angular/core';
import { UiControlValidatorDirective } from './ui-control-validator';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Directive({
  selector: '[uiControlValueAccessor]',
})
export class UiControlValueAccessorDirective<ValueType>
  extends UiControlValidatorDirective<ValueType>
  implements ControlValueAccessor, AfterViewInit
{
  @ViewChildren(UiControlValueAccessorDirective)
  private childControlValueAccessors: QueryList<UiControlValueAccessorDirective<ValueType>> | null = null;
  private _isDisabled$: Subject<boolean> = new Subject<boolean>();
  protected isDisabled$: Observable<boolean> = this._isDisabled$.asObservable();
  protected _value$: BehaviorSubject<ValueType | null> = new BehaviorSubject<ValueType | null>(null);
  public value$: Observable<ValueType | null> = this._value$.asObservable();

  ngAfterViewInit(): void {
    if (this.childControlValueAccessors) {
      this.childControlValueAccessors.forEach((item: UiControlValueAccessorDirective<ValueType>): void => {
        item.setDisabledState(this.control.disabled);
      });
    }
  }

  protected onChange: (value: ValueType | null) => ValueType | null = (value: ValueType | null) => value;

  protected onTouched: () => void = (): void => undefined;

  registerOnChange(fn: (value: ValueType | null) => ValueType | null): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(value: ValueType): void {
    this.control.setValue(value);
    this._value$.next(value);
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.control.disable({ emitEvent: false }) : this.control.enable({ emitEvent: false });
    this._isDisabled$.next(isDisabled);
  }
}
